import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NFLookupBankAccount } from "../../../../Shared/NewForms/NFLookupBankAccount";
import { NFLookupVendorCustomer } from "../../../../Shared/NewForms/NFLookupVendorCustomer";
import { NFLookupContract } from "../../../../Shared/NewForms/NFLookupContract";
import { useFormContext } from "react-hook-form";

const IncomingCashsReceivingFromBankDetail = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  return (
    <>
      <Row>
        <Col sm={6}>
          <NFLookupBankAccount fieldName="bankAccountId" title={t("BankAccount")} required />
        </Col>
        <Col sm={6}>
          <NFLookupVendorCustomer fieldName="vendorCustomerId" title={t("VendorsAndCustomers")} required />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupContract fieldName="contractId" title={t("Contract")} required />
        </Col>
      </Row>
    </>
  );
};

export default IncomingCashsReceivingFromBankDetail;
